import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CaoDetailsPopup } from './cao-details.widget.model';
import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';

@Component({
    selector: 'cmps-widget-cao-details',
    templateUrl: './cao-details.widget.component.html',
})
export class CaoDetailsWidgetComponent implements OnChanges {
    @Input()
    managerId: number;

    @Input()
    userId: number;

    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: CaoDetailsPopup;

    constructor(private readonly _service: LegacyWidgetService) {}

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        const change = changes['userId']; // only this should be changing
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (change != null && change.currentValue != null) {
            this.data = null;
            this.hasPendingData = true;
            this._service
                .caoDetailsPopup(this.managerId, this.userId)
                // eslint-disable-next-line no-return-assign
                .subscribe(
                    (data) => (this.data = data),
                    // eslint-disable-next-line n/handle-callback-err, no-return-assign
                    (error) => (this.hasPendingData = false),
                    // eslint-disable-next-line no-return-assign
                    () => (this.hasPendingData = false),
                );
        }
    }
}
